import { Component,PLATFORM_ID ,Inject,ElementRef, ViewChild} from '@angular/core';
import { CommonModule,isPlatformBrowser } from '@angular/common';
import { RouterOutlet } from '@angular/router';

import { MatDialogModule } from '@angular/material/dialog';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatProgressBarModule } from '@angular/material/progress-bar';

import { BaseChartDirective } from 'ng2-charts';
import { ChartConfiguration, ChartData } from 'chart.js';
import { Chart, registerables } from 'chart.js';

import { AnalysisOptionsComponent } from '../../tools/analysis-options/analysis-options.component';

import { HttpClient, HttpClientModule } from '@angular/common/http';
import { FacadeService } from '../../services/facade.service';
import { ProyectosService } from '../../services/proyectos.service';

Chart.register(...registerables);

//Variables del Navegador
type MenuItem = 'summary' | 'charts';

//Variable para expandir cada cuadro
interface ExpandedState {
  [key: string]: boolean;
}

interface WordCount {
  word: string;
  count: number;
}

interface Data {
  [key: string]: WordCount[];
}

interface DividedData {
  [key: string]: WordCount[][];
}

@Component({
  selector: 'metadiscourse',
  standalone: true,
  imports: [MatDialogModule,
    CommonModule,
    RouterOutlet,
    MatSidenavModule,
    MatExpansionModule,
    MatToolbarModule,
    MatIconModule,
    MatListModule,
    MatCardModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatMenuModule,
    MatSlideToggleModule,
    MatProgressBarModule,
    AnalysisOptionsComponent,
    BaseChartDirective,
    HttpClientModule],
  templateUrl: './metadiscourse.component.html',
  styleUrl: './metadiscourse.component.css'
})
export class MetadiscourseComponent {
  selectedMenuItem: MenuItem = 'summary';
  isScreenLarge: boolean = false;

  loaderActive: boolean;
  loaderActive2: boolean;
  loaderActiveFirstProject: boolean;

  UpdateMeta: boolean = false;

  private etiquetasMap: { [key: string]: string } = {};
  public data_pof = {};
  public data_pof3 = {};

  verifyLoaderActive2: boolean;

  imgSrc: { [key: string]: string } = {};

  isIconRotated = false;

  //Valores para expandir cada Cuadro
  public isExpanded = {};

  public encabezados = {};
  public colores_dinamicos = {};
  project_data: any;
  palabraresaltada = {};
  public ishighlighted = {};
  private categoryCounter = 1;

  private getExpansionKey(rawKey: string): string {
    return this.encabezados?.[rawKey]?.Name ?? rawKey;
  }

  respuestaWords: any[] = [
    { "value": "attitudeMarker", "descripcion": "Attitude marker" },
    { "value": "announceGoals", "descripcion": "Announce Goals" },
    { "value": "codeGloss", "descripcion": "Code gloss" },
    { "value": "emphatic", "descripcion": "Emphatic" },
    { "value": "endophoric", "descripcion": "Endophoric" },
    { "value": "evidential", "descripcion": "Evidential" },
    { "value": "hedge", "descripcion": "Hedge" },
    { "value": "labelStage", "descripcion": "Label stage" },
    { "value": "logicalConnective", "descripcion": "Logical connective" },
    { "value": "personMarker", "descripcion": "Person marker" },
    { "value": "relationalMarker", "descripcion": "Relational marker" },
    { "value": "sequencing", "descripcion": "Sequencing" },
    { "value": "topicShift", "descripcion": "Topic shift" },
  ];
  cambios_de_palabras = [];

   public hideEyeIconsForSafari1561 = false;

  ngOnInit(): void {
    localStorage.setItem("actual","meta")
    this.isButtonDisabled();
    this.hideEyeIconsForSafari1561 = false;
    if (isPlatformBrowser(this.platformId)) {
      this.isScreenLarge = window.innerWidth > 1000;
      window.addEventListener('resize', this.onResize.bind(this));
    }

    this.initSubscribe();
     if(sessionStorage.getItem("id_project")){
    this.initMetadiscourse();
     }
    if(sessionStorage.getItem("text_UID")){
      this.loaderActive = true;
    }
     this.proyectoService.loader$.subscribe(loader => {
      if(this.loaderActive2){
        this.loaderActive = false;
      }else{
        this.loaderActive = loader;
      }
    });

            this.proyectoService.loaderAnalyzing$.subscribe(loader => {
      if(loader){
        this.loaderActive2 = true;
      }
      if(!loader){
        this.loaderActive2 = false;
      }
    });

         this.proyectoService.loaderCreatingProject$.subscribe(value => {
      if(value){
        this.loaderActive2 = true;
      }
      if(!value){
        this.loaderActive2 = false;
      }
    });

            this.proyectoService.verifyloaderAnalyzing$.subscribe(value => {
      if(value){
        this.verifyLoaderActive2 = true;
      }
      if(!value){
        this.verifyLoaderActive2 = false;
      }
    });
  }

   public isSafariVersion1561(): boolean {
    const ua = navigator.userAgent;
    const safariMatch = ua.match(/Version\/([\d.]+) Safari\//);
    const isSafari = ua.includes("Safari") && ua.includes("Macintosh") && !ua.includes("Chrome");

    if (safariMatch && safariMatch[1] && isSafari) {
      return safariMatch[1] === "15.6.1";
    }

    return false;
  }

  public data: Data = {

  };


  async onSelectionRadioChange(palabra, position, origen, categoria, description) {
    let data = {
      "palabra":palabra,
      "origen": origen,
      "new_category": categoria,
      "position": position,
      "description": description
    }
    let editado = false
    for (let index = 0; index < this.cambios_de_palabras.length; index++) {
      let element = this.cambios_de_palabras[index];
      if (element.position == data.position){
        editado = true
        this.cambios_de_palabras[index] = data;
        break
      }
    }
    if (!editado){
      this.cambios_de_palabras.push(data)
    }
    this.proyectoService.undoMarcadoMultiple(this.http);
    // console.log(data);
  }

  encontrarCantidad(palabra, categoria){
    // categoria = categoria.toUpperCase()
    // console.log("categoria:"+categoria);
    return this.data_pof[categoria][palabra];
  }

  isWordSelected(valor, categoria, item){
    // console.log("Valor", valor, "Categoria",categoria)
    return (valor == categoria)
  }
  

  onResize() {
    this.isScreenLarge = window.innerWidth > 1000;
  }

  public colors = [
    '#32cd32',  
    '#9400d3',  
    '#1e90ff',  
    '#b22222',  
    '#add8e6',  
    '#bc8f8f',  
    '#daa520',  
    '#cd853f',  
    '#20b2aa',  
    '#bdb76b',
    '#156d31',  
    '#87cefa',  
    '#4b0082',  
    '#00bfff',  
    '#008080',  
    '#ffa07a',  
    '#0000cd',  
    '#8b0000',  
    '#deb887', 
    '#00ffff',
  ]

  //Dividir los datos obtenidos entre las 3 columnas al expandir la informacion

  public dividedData: DividedData = {};


  divideData() {
    for (const key in this.data_pof) {
      if (this.data_pof.hasOwnProperty(key)) {
        const items = this.data_pof[key];
        const chunkSize = Math.ceil(items.length / 3);
        this.dividedData[key] = [
          items.slice(0, chunkSize),
          items.slice(chunkSize, chunkSize * 2),
          items.slice(chunkSize * 2),
        ];
      }
    }
  }


  activeEyeIcon: HTMLImageElement | null = null;
  private proyectoSub;
  constructor(
    private http: HttpClient,
    public fachada: FacadeService,
    public proyectoService: ProyectosService,
    @Inject(PLATFORM_ID) private platformId: Object) {
    this.divideData();
  }

  status: any;
  async initMetadiscourse(){
      let pantalla_actual = localStorage.getItem("actual")
    if (pantalla_actual == "meta"){
      // Intentar recuperar el resumen desde sessionStorage
      const memoryStorage = sessionStorage.getItem("meta");
  
      if (memoryStorage && !this.UpdateMeta) {
        if(memoryStorage !== "-"){
        try {
          // Si existe, convertirlo de JSON string a objeto y asignarlo
          let respuesta = JSON.parse(memoryStorage);
          this.encabezados = respuesta.encabezados;
  
          this.data_pof = {};
          let colorIndex = 0
  
          this.etiquetasMap = {}; // Asegurar que el mapa de etiquetas esté vacío al inicio 
          this.categoryCounter = 1; // Resetear el contador al inicio
  
          for (const item of Object.keys(this.encabezados)) {
            const expansionKey = this.getExpansionKey(item);
            this.isExpanded[expansionKey] = this.isExpanded[expansionKey] ?? false;
            if(item == "unlisted" || item == "total"){
              this.colores_dinamicos[item] = 'transparent';
              this.etiquetasMap[item] = item;
            }else{
            this.colores_dinamicos[item] = this.colors[colorIndex]; 
            colorIndex = (colorIndex + 1) % this.colors.length
              if(!this.etiquetasMap[item]){
                this.etiquetasMap[item] = `mt${this.categoryCounter++}`;
              }
            }
          }
  
          for (const key in respuesta.taggeddata) {
            this.data_pof[key] = {};
            this.data_pof3[key] = {};
            for (const palabra in respuesta.taggeddata[key]) {
                this.data_pof[key][palabra] = respuesta.taggeddata[key][palabra].count;
                this.data_pof3[key][palabra] = respuesta.taggeddata[key][palabra].position;
            }
        }
   
          this.changecharData()
          // console.log(this.colores_dinamicos)
          // console.log(this.data_pof);
  
            for (const key in this.encabezados) {
              const expansionKey = this.getExpansionKey(key);
              this.isExpanded[expansionKey] = this.isExpanded[expansionKey] ?? false;
              this.ishighlighted[key] = this.ishighlighted[key] ?? false;
              const previousWordHighlights = this.palabraresaltada[key] ?? {};
              this.palabraresaltada[key] = {};
              for (const palabra in this.data_pof[key]) {
                  this.palabraresaltada[key][palabra] = previousWordHighlights[palabra] ?? false;
              }
            }
  
        } catch (error) {
          console.log("Error en la petición de datos")
          console.log(error)
          sessionStorage.removeItem('meta');
        }finally{
          this.loaderActive2 = false;
          this.loaderActive = false;
          this.loaderActiveFirstProject = false;
          this.proyectoService.updateloader(false);
        }
      }
      }
      if(!memoryStorage || this.UpdateMeta){
        sessionStorage.setItem("meta", "-");
        //Tenemos que esperar unos milisegundos en lo que el servicio actualiza la info
        await new Promise(resolve => setTimeout(resolve, 10));
        try {
          let textUID = sessionStorage.getItem('text_UID');
          let respuesta = await this.fachada.getMetadiscourseOfProject(this.http,textUID,"");
                // Guardar la respuesta en sessionStorage
          sessionStorage.setItem("meta", JSON.stringify(respuesta));
          this.encabezados = respuesta.encabezados;
  
          this.data_pof = {};
          let colorIndex = 0
  
          this.etiquetasMap = {}; // Asegurar que el mapa de etiquetas esté vacío al inicio 
          this.categoryCounter = 1; // Resetear el contador al inicio
  
          for (const item of Object.keys(this.encabezados)) {
            const expansionKey = this.getExpansionKey(item);
            this.isExpanded[expansionKey] = this.isExpanded[expansionKey] ?? false;
            if(item == "unlisted" || item == "total"){
              this.colores_dinamicos[item] = 'transparent';
              this.etiquetasMap[item] = item;
            }else{
            this.colores_dinamicos[item] = this.colors[colorIndex]; 
            colorIndex = (colorIndex + 1) % this.colors.length
              if(!this.etiquetasMap[item]){
                this.etiquetasMap[item] = `mt${this.categoryCounter++}`;
              }
            }
          }
  
          for (const key in respuesta.taggeddata) {
            this.data_pof[key] = {};
            this.data_pof3[key] = {};
            for (const palabra in respuesta.taggeddata[key]) {
                this.data_pof[key][palabra] = respuesta.taggeddata[key][palabra].count;
                this.data_pof3[key][palabra] = respuesta.taggeddata[key][palabra].position;
            }
        }
   
          this.changecharData()
          // console.log(this.colores_dinamicos)
          // console.log(this.data_pof);
  
            for (const key in this.encabezados) {
              const expansionKey = this.getExpansionKey(key);
              this.isExpanded[expansionKey] = this.isExpanded[expansionKey] ?? false;
              this.ishighlighted[key] = this.ishighlighted[key] ?? false;
              const previousWordHighlights = this.palabraresaltada[key] ?? {};
              this.palabraresaltada[key] = {};
              for (const palabra in this.data_pof[key]) {
                  this.palabraresaltada[key][palabra] = previousWordHighlights[palabra] ?? false;
              }
            }
            this.status = 200
  
        } catch (error) {
          if (error?.status === 0) {
            console.error("Error 500: Error interno del servidor (meta)");
            sessionStorage.removeItem('meta');
            this.status = 0

          } else {
            console.log("Otro error en la petición de datos")
            console.log(error)
            sessionStorage.removeItem('meta');
          }
          this.status = error?.status;
        }finally{
          if(this.status === 0){
            this.loaderActive2 = true;
            this.loaderActive = true;
            this.loaderActiveFirstProject = true;
            this.proyectoService.updateloader(true);
            this.UpdateMeta = true;
             setTimeout(() => {
              this.initMetadiscourse();
            }, 100);
          }else{
            this.loaderActive2 = false;
            this.loaderActive = false;
            this.loaderActiveFirstProject = false;
            this.proyectoService.updateloader(false);
            this.UpdateMeta = false;
          }
         
          
        }
      }
      }else{
      console.log(`meta no es la pantalla actual así que bloqueamos peticiones`)
    }
  }

  ngOnDestroy(): void {
    this.proyectoSub?.unsubscribe();
  }

  initSubscribe() {
    if (!this.proyectoSub || this.proyectoSub.closed) {
      //Subscribimos al servicio para escuchar los datos
      this.proyectoSub = this.proyectoService.proyecto$.subscribe(({ proyecto, firstProject })=>{
        if(!firstProject){
            this.loaderActive = false;
            if(sessionStorage.getItem("text_UID")){
              if(!this.loaderActiveFirstProject){
              this.loaderActive2 = true;
            }
            }else{
              this.loaderActive2 = false;
            }
          }
          if(firstProject){
            this.loaderActive = false;
            if(sessionStorage.getItem("text_UID")){
              this.loaderActiveFirstProject = true;
            }else{
              this.loaderActiveFirstProject = false;
            }
          }
        console.log("Update de data --Reporta: Metadiscourse--")
        this.project_data = proyecto;
         // Apagar todas las palabras resaltadas
        Object.keys(this.palabraresaltada).forEach(categoria => {
          Object.keys(this.palabraresaltada[categoria]).forEach(palabra => {
              this.palabraresaltada[categoria][palabra] = false;
          });
        });
  
        // Apagar todos los ojos de verPalabra
        Object.keys(this.palabraSeleccionada).forEach(key => {
          this.palabraSeleccionada[key] = false;
        });
  
         // **Apagar todas las palabras resaltadas activadas por toggleEyeIconPalabra**
        Object.keys(this.palabraresaltada).forEach(categoria => {
          Object.keys(this.palabraresaltada[categoria]).forEach(palabraResaltada => {
            this.palabraresaltada[categoria][palabraResaltada] = false;
          });
        });
  
        // Apagar ojos
        Object.keys(this.isEyeOn).forEach(categoria => {
          this.isEyeOn[categoria] = false;
        });
  
        this.categoriasActivas.clear();
        this.seeAllActive = false;
        this.seeAllIconSrc = '../../assets/images/eye-icon.svg';
  
        this.proyectoService.undoMarcadoMultiple(this.http);
        if(sessionStorage.getItem("id_project")){

        this.initMetadiscourse();
        }
      });
    }
  }
  
  getObjectKeys(obj: any): string[] {
    return Object.keys(obj);
  }

  changecharData() {
    // Limpiar las etiquetas y datasets existentes antes de agregar nuevos
    this.barChartData.labels = [];
    let dataset = {
      data: [],
      label: 'Unique Words',
      backgroundColor: [],
      barThickness: 40, // Hace las barras más delgadas
    };

    let maxValue = 0;
  
    for (const item of Object.keys(this.encabezados)) {
      const categoryKey = item.trim().toLowerCase();
      const categoryName = (this.encabezados[item].Name || '').trim().toLowerCase();
      const isExcludedCategory = categoryKey === 'total'
        || categoryName === 'total'
        || categoryName === 'totals'
        || categoryName === 'unlisted';

      if (!isExcludedCategory) {
        this.barChartData.labels.push(this.encabezados[item].Name);
        dataset.backgroundColor.push(this.colores_dinamicos[item]);
        const valueString = this.encabezados[item].typesPercent; 
        const value = parseFloat(valueString.replace('%', '')) || 0; 
        
        dataset.data.push(value);
        if (value > maxValue) { 
          maxValue = value;
          
          } 
      }
    }
  
    // Reemplazar los datasets existentes en lugar de agregarlos
    this.barChartData.datasets = [dataset];
    this.updateChartOptions(Math.ceil(maxValue));
  }

  updateChartOptions(maxValue: number) {
    const stepSize = Math.ceil(maxValue / 5); // Ajustar el tamaño del paso en función del valor máximo
  
    this.barChartOptions = {
      scales: {
        x: {
          grid: {
            display: false, // Ocultar las líneas verticales
          },
        },
        y: {
          min: 0,
          max: maxValue, // Ajuste según el valor máximo calculado
          ticks: {
            stepSize: stepSize, // Incrementos calculados
            callback: function (value) {
              return value + '%'; // Mostrar el símbolo % en las etiquetas
            }
          },
          border: {
            display: false, // Eliminar el borde del eje Y
          },
          grid: {
            color: '#E0E0E0', // Color de las líneas horizontales
          },
        },
      },
      plugins: {
        legend: {
          display: false, // Ocultar la leyenda
        },
        datalabels: {
              display: false // Desactiva los datalabels solo en este gráfico
            },
      },
    };
  }
  

  getRandomHexColor(): string {
    // Define un umbral para evitar colores muy claros (por ejemplo, evita valores mayores a 0xEEEEEE)
    const maxColorValue = 0xEEEEEE;
    const minColorValue = 0x000000; // Puedes ajustar este valor si no quieres colores muy oscuros

    // Genera un número aleatorio en el rango permitido
    const randomColor = Math.floor(Math.random() * (maxColorValue - minColorValue + 1)) + minColorValue;

    // Convierte el número a una cadena hexadecimal y asegúrate de que tenga siempre 6 dígitos
    return '#' + randomColor.toString(16).padStart(6, '0').toUpperCase();
  }

  toggleIcon() {
    this.isIconRotated = !this.isIconRotated;
  }

  resetIcon() { this.isIconRotated = false; }

  //Funcion para expandir cada cuadro
  toggleExpand(identifier: string) {
    this.isExpanded[identifier] = !this.isExpanded[identifier];
  }

  toggleExpandAll() {
    const expandableKeys = Object.keys(this.encabezados)
      .filter(key => key !== 'total')
      .map(key => this.getExpansionKey(key));

    const allExpanded = expandableKeys.length > 0 && expandableKeys.every(key => this.isExpanded[key]);

    expandableKeys.forEach(key => {
      this.isExpanded[key] = !allExpanded;
    });

    this.showAll = allExpanded;

}



  showAll: boolean = true; 

  selectMenuItem(menuItem: MenuItem) {
    this.selectedMenuItem = menuItem;
  }

  isSelected(menuItem: MenuItem): boolean {
    return this.selectedMenuItem === menuItem;
  }



  public barChartOptions: ChartConfiguration<'bar'>['options'] = {
    scales: {
      x: {
        grid: {
          display: false,  // Ocultar las líneas verticales
        },
      },
      y: {
        min: 0,
        max: 2.5,  // Límite máximo del eje Y en 25%
        ticks: {
          stepSize: .5,  // Incrementos de 5% en 5%
          callback: function (value) {
            return value + '%';  // Mostrar el símbolo % en las etiquetas
          }
        },
        border: {
          display: false  // Eliminar el borde del eje Y
        },
        grid: {
          color: '#E0E0E0',  // Color de las líneas horizontales
        },
      },
    },
    plugins: {
      legend: {
        display: false, // Ocultar la leyenda
      },
      datalabels: {
              display: false // Desactiva los datalabels solo en este gráfico
            },
    },
  };

getCategoryDescription(data: string): string {
  const descriptions: { [key: string]: string } = {
    'announce goal': 'A word or phrase used to signal the purpose or intention behind what is being said. They help orient the audience to what the writer or speaker aims to achieve, often found in academic writing to make goals clear (e.g., "In this paper, I will...").',
    'code glosse': 'These are markers that provide clarification or further explanation of terms or concepts. They function to define or elaborate on what has been said to ensure the audience understands (e.g., "i.e.," "that is to say," "such as").',
    'endophoric': 'These markers refer to something within the text itself, often used to link statements back to previous parts of the text. They guide the reader by pointing to other content in the same discourse (e.g., "as we saw earlier," "this shows that").',
    'hedge': 'A word or phrase used to soften the impact of a statement, making it less direct or less assertive. They are used to express uncertainty, possibility, or politeness (e.g., "might," "seem," "possibly," "perhaps").',
    'logical connective': 'A word or phrase used to link ideas, sentences, or clauses together logically, helping to structure the argument or discussion. They show relationships like cause-effect, contrast, addition, etc. (e.g., "therefore," "however," "in addition," "because").',
    'relational marker': 'A word or phrase showing the relationship between the writer and the audience. They guide interaction, expressing the writer\'s stance toward the audience or information (e.g., "as you can see," "let me clarify," "I believe").',
    'attitude marker': 'A word or phrase used to convey the writer\'s attitude or opinion about the information presented, allowing the writer to express evaluation or stance (e.g., "unfortunately," "interestingly," "surprisingly").',
    'emphatic': 'Serve to strengthen or emphasize a particular point or statement. They make the writer\'s claim more forceful or certain (e.g., "definitely," "absolutely," "clearly," "undoubtedly").',
    'evidential': 'An indication of the source of the information, showing where the writer\'s knowledge or evidence comes from. They help establish the reliability of the claims (e.g., "according to," "as reported by," "based on studies").',
    'label stage': 'Used to label different phases or parts of a discourse or text. They structure the argument or presentation by indicating where one stage ends and another begins (e.g., "First," "Next," "To conclude").',
    'person marker': 'Indicating the involvement or perspective of the writer or others in the discourse. They specify who is taking the action or being referred to (e.g., "I," "we," "you," "they").',
    'sequencing': 'Used to organize content in a sequential order, guiding the audience through the structure of an argument or narrative. They help clarify the flow of ideas (e.g., "Firstly," "Then," "Finally").',
    'topic shift': 'A word or phrase that indicates a shift in the topic or focus of the discourse. They help signal when the conversation or discussion is moving from one subject to another (e.g., "Now let\'s turn to," "On a different note," "Regarding").'
  };

  const normalize = (str: string) =>
    str.replace(/([a-z])([A-Z])/g, '$1 $2').toLowerCase(); // camelCase → con espacios

  const normalizedKey = normalize(data);
  return descriptions[normalizedKey] || 'No description available.';
}




  public barChartType = 'bar' as const;

  public barChartData: ChartData<'bar'> = {
    labels: [],
    datasets: [
      {
        data: [],
        label: '',
        backgroundColor: [
          '#6C2D8E',  // Naranja
          '#0075FF',  // Verde
          '#1A8583',  // Rojo
          '#F60D16',  // Verde claro
          '#15622B',  // Azul
          '#FF8EC5',  // Púrpura
          '#8E8E5B',
          '#C5C500',

        ],
        // Hace las barras más delgadas
        barThickness: 30,
      },
    ],
  };



  ponerOjo(event: MouseEvent, categoria: string, palabra: string): void {
    const element = event.currentTarget as HTMLElement;
  
    // Cambiar el fondo del contenedor
    element.style.background = "#FAE29E";
  
    // Mostrar los íconos
    const eyeIcons = element.querySelectorAll('.icon-eye');
  
    eyeIcons.forEach((icon) => {
      (icon as HTMLElement).style.visibility = "visible";
    });
  
  }
  
  quitarOjo(event: MouseEvent, categoria: string, palabra: string): void {
    const element = event.currentTarget as HTMLElement;
  
    // Restaurar el fondo del contenedor
    element.style.background = "transparent";
  
    // Ocultar los íconos
    const eyeIcons = element.querySelectorAll('.icon-eye');
  
    
  
  }
  

selectedWord: { [key: string]: string | null } = {};

selectWord(category: string, word: string): void {

  
  // Resetear todas las selecciones en otras categorías
  for (const cat in this.selectedWord) {
    if (cat !== category) {
      this.selectedWord[cat] = null;
    }
  }

  // Seleccionar la nueva palabra en la categoría actual
  this.selectedWord[category] = word;
}

async resetCategoryView(category: string) {

    this.selectedWord[category] = null;
  }

async updateCategory(category: string){
  if (this.cambios_de_palabras.length === 0) {

    this.selectedWord[category] = null;
  }else{
      this.UpdateMeta = true;
      this.selectedWord[category] = null; // Resetea la selección para mostrar la lista completa

      await this.cambios_de_palabras.sort((a, b) => a.position - b.position);
      let data = {
        "palabras": this.cambios_de_palabras
      }

      await this.fachada.UpdateMetadiscourseWordCategory(this.http, sessionStorage.getItem('text_UID'), data)
      this.cambios_de_palabras = [];
      this.initMetadiscourse()
      setTimeout(() => {
        this.proyectoService.undoMarcadoMultiple(this.http);
        this.seeAllIconSrc = '../../assets/images/eye-icon.svg';
        Object.keys(this.isEyeOn).forEach(categoria => {
          this.isEyeOn[categoria] = false;
        });
        Object.keys(this.palabraresaltada).forEach(categoria => {
          Object.keys(this.palabraresaltada[categoria]).forEach(palabraResaltada => {
            this.palabraresaltada[categoria][palabraResaltada] = false;
          });
          Object.keys(this.palabraSeleccionada).forEach(key => {
            this.palabraSeleccionada[key] = false;
          });
        });
      }, 1000);
  }
}

  
updateSeeAllIcon(): void {
  const allSelected = Object.keys(this.ishighlighted)
      .filter(key => key !== 'total') // Evitar "Totals"
      .every(key => this.ishighlighted[key]);
  const seeAllButtonIcon = document.querySelector('.see-all-icon') as HTMLImageElement;

  if (seeAllButtonIcon) {
      seeAllButtonIcon.src = allSelected
          ? './assets/images/yellow_icons/eye-on-icon.svg'
          : './assets/images/eye-icon.svg';
      
  }
}


palabraSeleccionada: { [key: string]: boolean } = {};
verPalabra(palabra: string, categoria: string, index: number, desdeOjo: boolean = true): void {
  const categoriaUpper = categoria;
  const key = `${categoriaUpper}-${palabra}-${index}`;



  // Verificar si la categoría existe
  if (!this.data_pof3[categoriaUpper]) {
    console.error(`No se encontró la categoría "${categoriaUpper}".`);
 
    return;
  }

  // Verificar si la palabra existe dentro de la categoría
  const palabraData = this.data_pof3[categoriaUpper]?.[palabra];

  if (!palabraData || !Array.isArray(palabraData) || palabraData.length === 0) {
    console.error(`No se encontró la palabra "${palabra}" en la categoría "${categoriaUpper}" o no tiene posiciones válidas.`);
  
    return;
  }

  

  // Si el ojo está encendido y lo presionas, se apaga
  if (desdeOjo && this.palabraSeleccionada[key]) {
    this.palabraSeleccionada[key] = false;
    
    this.proyectoService.undoMarcadoMultiple(this.http);
    return;
  }

  // **Apagar todas las palabras resaltadas activadas por toggleEyeIconPalabra**
  Object.keys(this.palabraresaltada).forEach(categoria => {
    Object.keys(this.palabraresaltada[categoria]).forEach(palabraResaltada => {
      this.palabraresaltada[categoria][palabraResaltada] = false;
    });
  });

  // Primero apagamos todas las palabras antes de encender una nueva (excepto si es el mismo ojo)
  Object.keys(this.palabraSeleccionada).forEach(k => {
    this.palabraSeleccionada[k] = false;
  });

  // Encender la palabra seleccionada
  this.palabraSeleccionada[key] = true;

  // Recopilar posiciones de la palabra en la categoría seleccionada
  const posicionesSeleccionadas: { posicion: number; categoria: string }[] = palabraData.map(pos => ({
    posicion: pos,
    categoria: categoriaUpper
  }));

 

  // Verificar que el índice solicitado es válido
  if (index < 0 || index >= posicionesSeleccionadas.length) {
    console.error(`Índice fuera de rango: ${index}`);
    return;
  }

  // Obtener la posición específica de la palabra seleccionada en la categoría
  const posicionSeleccionada = posicionesSeleccionadas[index].posicion;

  

  // Recopilar posiciones de todas las categorías
  const posicionesOtrasCategorias: { posicion: number; categoria: string }[] = [];
  Object.keys(this.data_pof3).forEach(key => {
    if (key !== categoriaUpper) {
      const palabraEnCategoria = this.data_pof3[key]?.[palabra];
      if (palabraEnCategoria && Array.isArray(palabraEnCategoria) && palabraEnCategoria.length > 0) {
        palabraEnCategoria.forEach(pos => {
          posicionesOtrasCategorias.push({ posicion: pos, categoria: key });
        });
      }
    }
  });


  // Combinar todas las posiciones
  const todasLasPosiciones = [...posicionesSeleccionadas, ...posicionesOtrasCategorias];

  // Ordenar todas las posiciones de menor a mayor
  todasLasPosiciones.sort((a, b) => a.posicion - b.posicion);

 

  // Determinar el orden de la palabra seleccionada en el texto
  const ordenSeleccionado = todasLasPosiciones.findIndex(
    posObj => posObj.categoria === categoriaUpper && posObj.posicion === posicionSeleccionada
  );

  if (ordenSeleccionado !== -1) {
    

    const etiqueta = this.etiquetasMap[categoriaUpper] || `mt${this.categoryCounter++}`;
this.proyectoService.resaltarCoincidenciaOrdenada(
    palabra,
    etiqueta, // Usamos la etiqueta "mtX" en lugar de categoriaUpper
    todasLasPosiciones,
    ordenSeleccionado + 1, // Empieza en 1
    this.http
);
  } else {
    console.log(`No se encontró orden válido para la posición ${posicionSeleccionada} en la categoría "${categoriaUpper}".`);
  }
}

isEyeOn: { [key: string]: boolean } = {};
categoriasActivas: Set<string> = new Set();

toggleEyeIcon(data: string): void {
  const categoriaUpper = data;

  if (!this.data_pof3[categoriaUpper]) {
    console.error(`No se encontró la categoría "${categoriaUpper}".`);
    return;
  }
  // Apagar todos los ojos de verPalabra
  Object.keys(this.palabraSeleccionada).forEach(key => {
    this.palabraSeleccionada[key] = false;
  });

  const estadoActual = this.isEyeOn[categoriaUpper] || false;

  if (estadoActual) {
    this.categoriasActivas.delete(categoriaUpper);
    this.isEyeOn[categoriaUpper] = false;

    // Si "See All" estaba activo y desactivamos una categoría, apagamos solo el botón sin resetear todo
    if (this.seeAllActive) {
      this.seeAllActive = false;
    }

    // Si era la única categoría activa, llamar `undoMarcadoMultiple()`
    if (this.categoriasActivas.size === 0) {
      this.proyectoService.undoMarcadoMultiple(this.http);
    } else {
      this.actualizarResaltadoTexto();
    }
  } else {
    this.categoriasActivas.add(categoriaUpper);
    this.isEyeOn[categoriaUpper] = true;

    // **Apagar todos los ojos de las palabras**
    Object.keys(this.palabraresaltada).forEach(categoria => {
      Object.keys(this.palabraresaltada[categoria]).forEach(palabra => {
        this.palabraresaltada[categoria][palabra] = false;
      });
    });

    this.actualizarResaltadoTexto();
  }

  // Solo activar "See All" si todas las categorías están prendidas
  const allOn = Object.keys(this.data_pof3).every(categoria => this.isEyeOn[categoria]);
  this.seeAllActive = allOn;
  this.seeAllIconSrc = allOn
      ? '../../assets/images/yellow_icons/eye-on-icon.svg'
      : '../../assets/images/eye-icon.svg';
}


// Método para actualizar el resaltado en el texto considerando solo las categorías activas
actualizarResaltadoTexto(): void {
  let posicionesGlobales: { categoria: string; palabra: string; posicion: number }[] = [];

  // Recorrer todas las categorías disponibles para capturar todas las coincidencias
  Object.keys(this.data_pof3).forEach(categoria => {
      Object.keys(this.data_pof3[categoria]).forEach(palabra => {
          this.data_pof3[categoria][palabra].forEach(posicion => {
              posicionesGlobales.push({ categoria, palabra, posicion });
          });
      });
  });

  // Ordenar todas las posiciones de acuerdo con su aparición en el texto
  posicionesGlobales.sort((a, b) => a.posicion - b.posicion);

  // Mapear palabras con su posición y la categoría más relevante
  let posicionesPorPalabra: { [key: string]: { posicion: number; categoria: string }[] } = {};

  posicionesGlobales.forEach(({ categoria, palabra, posicion }) => {
      if (!posicionesPorPalabra[palabra]) {
          posicionesPorPalabra[palabra] = [];
      }
      posicionesPorPalabra[palabra].push({ posicion, categoria });
  });

  // Condición para manejar una categoría seleccionada vs. múltiples categorías activas
  if (this.categoriasActivas.size === 1) {
      // Caso de una sola categoría activa: aplicar lógica específica
      const categoriaUnica = [...this.categoriasActivas][0];

      this.proyectoService.resaltarMultiplesCoincidenciasCategoriaMeta(
          Object.keys(this.data_pof3[categoriaUnica]),
          categoriaUnica,
          posicionesPorPalabra,this.etiquetasMap,
          this.http
      );
  } else {
      // Caso de múltiples categorías activas: aplicar resaltado estándar
      let posicionesFiltradas: { [key: string]: { posicion: number; categoria: string }[] } = {};

      // Filtrar posiciones por categorías activas y ordenar por posición
      Object.keys(posicionesPorPalabra).forEach(palabra => {
          // Filtrar solo las posiciones de las categorías activas
          posicionesFiltradas[palabra] = posicionesPorPalabra[palabra]
              .filter(({ categoria }) => this.categoriasActivas.has(categoria))
              // Ordenar las posiciones por su valor 'posicion'
              .sort((a, b) => a.posicion - b.posicion);
      });

      this.proyectoService.aplicarResaltadoMeta(posicionesFiltradas,this.etiquetasMap,this.http);
  }
}



seeAllHighlighted: boolean = false; // Controla el estado del botón "See All"
seeAllIconSrc: string = '../../assets/images/eye-icon.svg'; // Controla el ícono del botón "See All"
  

toggleEyeIconPalabra(data: string, palabra: string): void {
  const categoriaUpper = data;

  if (!this.data_pof3[categoriaUpper] || !this.data_pof3[categoriaUpper][palabra]) {
    console.error(`No se encontró la palabra "${palabra}" en la categoría "${categoriaUpper}".`);
    return;
  }

  const estadoActual = this.palabraresaltada[categoriaUpper]?.[palabra];
  if (estadoActual) {
    this.palabraresaltada[categoriaUpper][palabra] = false;
    this.proyectoService.undoMarcado([palabra], categoriaUpper);
    return;
  }
  

  // **Apagar todas las palabras resaltadas en TODAS las categorías antes de activar la nueva**
  Object.keys(this.palabraresaltada).forEach(categoria => {
    Object.keys(this.palabraresaltada[categoria]).forEach(palabraResaltada => {
      this.palabraresaltada[categoria][palabraResaltada] = false;
    });
  });

  Object.keys(this.palabraresaltada[categoriaUpper] || {}).forEach(key => {
    this.palabraresaltada[categoriaUpper][key] = false;
  });

  // **Apagar todos los ojos visibles**
  Object.keys(this.isEyeOn).forEach(categoria => {
    this.isEyeOn[categoria] = false;
  });
  this.categoriasActivas.clear();
  this.seeAllActive = false;
  this.seeAllIconSrc = '../../assets/images/eye-icon.svg';

  // **También asegurarse de que las imágenes de los ojos se actualicen correctamente en palabraSeleccionada**
  Object.keys(this.palabraSeleccionada).forEach(key => {
    this.palabraSeleccionada[key] = false;
  });

  // **Organizar posiciones globalmente sin alterar resaltarMultiplesCoincidencias**
  let posicionesGlobales: { categoria: string; palabra: string; posicion: number }[] = [];

  Object.keys(this.data_pof3).forEach(categoria => {
    Object.keys(this.data_pof3[categoria]).forEach(palabra => {
      this.data_pof3[categoria][palabra].forEach(posicion => {
        posicionesGlobales.push({ categoria, palabra, posicion });
      });
    });
  });

  posicionesGlobales.sort((a, b) => a.posicion - b.posicion);

  let posicionesPorPalabra: { [key: string]: { posicion: number; categoria: string }[] } = {};

  posicionesGlobales.forEach(({ categoria, palabra, posicion }) => {
    if (!posicionesPorPalabra[palabra]) {
      posicionesPorPalabra[palabra] = [];
    }
    posicionesPorPalabra[palabra].push({ posicion, categoria });
  });

  this.palabraresaltada[categoriaUpper][palabra] = true;

  // **Enviar datos a proyectoService sin alterar su lógica**
  this.proyectoService.resaltarMultiplesCoincidenciasMeta([palabra], categoriaUpper, posicionesPorPalabra,this.etiquetasMap,this.http);

}


seeAllActive: boolean = false;
toggleSeeAll(): void {
  const allOn = !this.seeAllActive; // Invertir el estado actual

// Apagar todas las palabras resaltadas
Object.keys(this.palabraresaltada).forEach(categoria => {
  Object.keys(this.palabraresaltada[categoria]).forEach(palabra => {
      this.palabraresaltada[categoria][palabra] = false;
  });
});

// Apagar todos los ojos de verPalabra
Object.keys(this.palabraSeleccionada).forEach(key => {
  this.palabraSeleccionada[key] = false;
});


  
  // **Actualizar el estado de cada categoría correctamente**
  Object.keys(this.data_pof3).forEach(categoria => {
      this.isEyeOn[categoria] = allOn;
      if (allOn) {
          this.categoriasActivas.add(categoria);
      } else {
          this.categoriasActivas.delete(categoria);
      }

  });

  // Actualizar el estado del botón "See All"
  this.seeAllActive = allOn;
  this.seeAllIconSrc = allOn
      ? '../../assets/images/yellow_icons/eye-on-icon.svg'
      : '../../assets/images/eye-icon.svg';

  if (allOn) {
      // Resaltar todas las categorías
      let posicionesGlobales: { categoria: string; palabra: string; posicion: number }[] = [];

      Object.keys(this.data_pof3).forEach(categoria => {
          Object.keys(this.data_pof3[categoria]).forEach(palabra => {
              this.data_pof3[categoria][palabra].forEach(posicion => {
                  posicionesGlobales.push({ categoria, palabra, posicion });
              });
          });
      });

      posicionesGlobales.sort((a, b) => a.posicion - b.posicion);

      let posicionesPorPalabra: { [key: string]: { posicion: number; categoria: string }[] } = {};

      posicionesGlobales.forEach(({ categoria, palabra, posicion }) => {
          if (!posicionesPorPalabra[palabra]) {
              posicionesPorPalabra[palabra] = [];
          }
          posicionesPorPalabra[palabra].push({ posicion, categoria });
      });

      this.proyectoService.resaltarTodasLasCategoriasMeta(posicionesPorPalabra,this.etiquetasMap,this.http);
  } else {
      // Solo ejecutar `undoMarcadoMultiple()` cuando "See All" estaba activado y ahora se apaga
      this.proyectoService.undoMarcadoMultiple(this.http);
  }
}
  

  export_detallado(){
    let respaldo_ID = document.getElementById("PROJECT_ID_RESPALDO") as HTMLInputElement
    if(respaldo_ID){
      if (respaldo_ID.value != '' && respaldo_ID.value != null){
        this.fachada.detail_export("metadiscourse", respaldo_ID.value)
      }else{
        alert("No hay proyecto cargado")
      }
    }else{
      alert("No esta en la página principal")
    }
  }

  export_tagger(){
    let respaldo_ID = document.getElementById("PROJECT_ID_RESPALDO") as HTMLInputElement
    if(respaldo_ID){
      if (respaldo_ID.value != '' && respaldo_ID.value != null){
        this.fachada.tagger_export("metadiscourse", respaldo_ID.value)
      }else{
        alert("No hay proyecto cargado")
      }
    }else{
      alert("No esta en la página principal")
    }
  }

  isButtonDisabled(): boolean {
    return !sessionStorage.getItem("text_UID"); 
  }
}
